import { api } from "constants/RotasAPI";
import { useMutation } from "react-query";
import { toast } from "react-hot-toast";
import { http } from "shared/util/http";
import { CadastroContasPagarUnicaGroupPayRequest } from "types/request/groupPay/CadastroContasPagarUnicaGroupPayRequest";

export const usePostCadastrarDespesaUnicaGroupPay = () => {
  const mutationFn = async (requestData: CadastroContasPagarUnicaGroupPayRequest): Promise<void> => {
    await http.post(api.contasPagar.postCadastrarDespesaUnicaGroupPay, requestData);
  };

  return useMutation(mutationFn, {
    onSuccess: () => {
      toast.success("Despesa cadastrada com sucesso!");
    },
    onError: (error: any) => {
      const message = error?.response?.data?.validation?.[0]?.message || error?.response?.data?.message;

      if (message) {
        toast.error(message);
      } else {
        toast.error("Erro ao cadastrar despesa");
      }
    },
  });
};
